import getUrl from "./rest";
import http from "./http";

const API = "auctionnfts";

const auctionService = {
  getAll: (filters = {}, headers) =>
    http.get(getUrl(`${API}`), filters, headers),
  getById: (id, headers) => http.get(getUrl(`${API}/${id}`), null, headers),
  getDetailsByTokenId: (tokenId, headers) =>
    http.get(getUrl(`${API}/details/tokenId/${tokenId}`), null, headers),
};

export default auctionService;
